var t=t=>{let e=t.length,r=Array(e);for(let a=0;a<e;a++)r[a]=Number(t.charCodeAt(a)).toString(16);return r.join("")};export{t as default};